import { EntityTracking } from '@bark/bark-core';

const isDebug = () => new URL(window.location.href).searchParams.get('debug') === '1';

const entityTracking = new EntityTracking({ nameFormat: 'title', debug: isDebug() });

export default async function () {
	$(window).on('load', function () {
		const sellerProfileId = document
			.getElementById('job-service_seller-id')
			?.getAttribute('value');

		entityTracking.createEvents([
			{
				id: 'cta_click',
				name: 'Page CTA Event',
				entities: ['page', 'seller_job', 'availability'],
				group: 'Seller services jobs',
			},
			{
				id: 'page_load',
				name: 'Page Load',
				entities: ['page'],
				group: 'Seller services jobs',
			},
		]);

		entityTracking.createEntity({
			id: 'page',
			data: {
				seller_profile_id: sellerProfileId,
			},
		});

		window.SellerSettingsApp?.launchModule(
			'seller-settings-routes',
			'__sellerJobServices',
			{
				entityTracking,
				sellerProfileId,
			},
		);
	});
}
